export default __webpack_public_path__ + "static/media/GreenCanvas.f73d1357.webp";